// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"ffd25d307ca84ed12848","865":"ffd25d307ca84ed12848","2740":"ffd25d307ca84ed12848","4887":"ffd25d307ca84ed12848","6153":"ffd25d307ca84ed12848","6650":"2130614b8b7fa168a19f"}[chunkId] + ".chunk.css";
};